import { Component, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { AccessBlockerService } from 'src/shared/services/access-blocker.service';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-access-blocker',
    templateUrl: './access-blocker.component.html',
    styleUrl: './access-blocker.component.less',
    imports: [
        CommonModule,
        MatIconModule,
    ]
})

export class AccessBlockerComponent implements OnInit {

  constructor(
    private accessBlockerService: AccessBlockerService,
    private router: Router
  ) { }

  ngOnInit(): void {

    /** Emite o valor do subject para chacoalhar o card de inadimplência **/
    this.accessBlockerService.triggerShakeSubject$.subscribe(() => this.shakeCard());

    /** Armazena a rota atual **/
    this.currentRoute = this.router.url;
  }

  /** Propriedade utilizada para armazenar a rota atual **/
  public currentRoute: string = '';

  /** Propriedade utilizada para manipular quando o efeito de chacoalhar o card será realizado **/
  public cardIsShake: boolean = false;

  /** Método utilizado para "chacoalhar" o card de bloqueio por inadimplência **/
  public shakeCard() {
    this.cardIsShake = false;
    setTimeout(() => (this.cardIsShake = true), 400);
  }
}
